module.exports = __webpack_public_path__ + "img/partner_Pyth @2x.e8cedf20.png";